import { fetchRemoteResult } from '@core/Api/api-util';

const endpoint = '/ucidanalysis/api/';

const api = Object.freeze({
    async getAnalysis(analysisId) {
        //We may assume success - our backend should have already validated access
        //We dont account for connection errors etc.
        return await fetchRemoteResult(`${endpoint}${analysisId}`);
    },
    
    async updateAnalysisAnswers(analysisId, answers) {
        await fetchRemoteResult(`${endpoint}${analysisId}/answers`, {
          method: 'PATCH',
          body: JSON.stringify(answers),
          headers: {
              'content-type': 'application/json'
          }
        });
    },
    
    async finishAnalysis(analysisId) {
        await fetchRemoteResult(`${endpoint}${analysisId}/finish`, {
            method: 'PATCH'
        });
    }
});

export default api;